export const basicPageOption = {
  border: true,
  index: false,
  menuWidth: 280,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  addBtn: false,
  delBtn: false,
  search: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      width: 50,
      search: false,
      hide: true,
    }, {
      label: '页面名字',
      prop: 'name',
      width: 200,
      search: false
    }, {
      label: '描述',
      prop: 'description',
      slot:true,
      width: 260,
      search: false
    }, {
      label: '页面标识',
      prop: 'code',
      width: 100,
      search: false,
    }, {
      label: '创建者',
      prop: 'creator',
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      sortable: true,
    }]
}
